import { render, staticRenderFns } from "./inventory-form.vue?vue&type=template&id=b610da52&scoped=true&"
import script from "./inventory-form.vue?vue&type=script&lang=js&"
export * from "./inventory-form.vue?vue&type=script&lang=js&"
import style0 from "./inventory-form.vue?vue&type=style&index=0&id=b610da52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b610da52",
  null
  
)

export default component.exports